import React from 'react';
type MotifProps = {
  className?: string;
};

/**
 * Motivos de línea de la identidad DPS46 (trazo fino, heredan currentColor).
 * - BoardMotif: anillos concéntricos que se expanden (la respiración).
 *   Se mantiene el nombre para no romper imports de la estructura original.
 * - BreathWave: la respiración como ola.
 * - CircleOfMats: un círculo de colchonetas vistas desde arriba, con una ola
 *   en el centro (el círculo grupal).
 */
export function BoardMotif({
  className
}: MotifProps) {
  return <svg viewBox="0 0 240 240" aria-hidden="true" className={className} data-id="element-21" data-mp="3ljsalpcs3n4w">
      <g fill="none" stroke="currentColor" strokeLinecap="round" data-id="element-22" data-mp="37sdt5myirtzy">
        <circle cx="120" cy="120" r="100" strokeWidth="3" strokeDasharray="560 68" transform="rotate(-58 120 120)" data-id="element-23" data-mp="37tykz4tg8yu4" />
        <circle cx="120" cy="120" r="68" strokeWidth="2.5" opacity="0.7" data-id="element-24" data-mp="2xug5b0kknz7v" />
        <circle cx="120" cy="120" r="38" strokeWidth="2" opacity="0.5" data-id="element-25" data-mp="32rzj5zdcy9za" />
      </g>
      <circle cx="120" cy="120" r="6" fill="currentColor" data-id="element-26" data-mp="1oo23bpr00bep" />
    </svg>;
}
export function BreathWave({
  className
}: MotifProps) {
  return <svg viewBox="0 0 240 80" aria-hidden="true" className={className} data-id="element-27" data-mp="1joz1ee6belay">
      <path d="M0 40 C30 8 50 8 80 40 S130 72 160 40 S210 8 240 40" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" data-id="element-28" data-mp="1xo6zt4unlpe3" />
    </svg>;
}
export function CircleOfMats({
  className
}: MotifProps) {
  const angles = [0, 45, 90, 135, 180, 225, 270, 315];
  return <svg viewBox="0 0 240 150" aria-hidden="true" className={className} data-id="element-29" data-mp="110tzzdd4rcfb">
      <g fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" data-id="element-30" data-mp="1erfj936hxodq">
        {angles.map(a => <rect key={a} x="115" y="13" width="10" height="24" rx="4" strokeWidth="2.5" transform={`rotate(${a} 120 75)`} data-id="element-31" data-mp="19y4dz6hc1fnx" />)}
        <path d="M98 75 q5.5 -10 11 0 t11 0 t11 0 t11 0" strokeWidth="2.5" data-id="element-32" data-mp="2hd9by56rc3ll" />
      </g>
    </svg>;
}

/** Alias por compatibilidad con la estructura original. */
export const TwoChairs = CircleOfMats;